exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Wath__root___3WDGY {\n  border-top: 1px solid transparent;\n  position: relative;\n}\n\n.Wath__content___3Aeda {\n  margin-top: 17.5rem;\n  margin-bottom: 14.63rem;\n  position: relative;\n}\n\n.Wath__desc___1BTEv {\n  max-width: 41.778em;\n}\n\n.Wath__shape___1Gdys {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  z-index: 1;\n}\n\n.Wath__shape1___2NT7J {\n  bottom: 0;\n  left: -10.5vw;\n  width: 21.19vw;\n}\n\n.Wath__shape2___2vUlq {\n  top: 57%;\n  right: 21%;\n  width: 7.1875vw;\n}\n\n.Wath__shape3___1jdo7 {\n  top: 0;\n  right: -21.5rem;\n  width: 38.125vw;\n}\n\n@media (max-width: 60em) {\n  .Wath__content___3Aeda {\n    margin-top: 5.625rem;\n    margin-bottom: 6.63rem;\n  }\n}", ""]);

// exports
exports.locals = {
	"root": "Wath__root___3WDGY",
	"content": "Wath__content___3Aeda",
	"desc": "Wath__desc___1BTEv",
	"shape": "Wath__shape___1Gdys",
	"shape1": "Wath__shape1___2NT7J",
	"shape2": "Wath__shape2___2vUlq",
	"shape3": "Wath__shape3___1jdo7"
};